import { AIForMeTool, sortingOptions, SortOption } from "lib/models/aiforme-models";
import { AmazonianInformation } from "lib/models/oui-models";
import { FeedbackModelRecord } from "lib/services/catalogical-models";
import { UserInformation } from "lib/services/user-information-service";
import { useState } from "react";

// Interface that defines the shape of the state used for security order handling.
export interface AllAiToolsState {
  userFeedbacks: Record<string, FeedbackModelRecord>;
  error: Error | undefined;
  searchText: string | undefined;
  searchInputValue: string;
  selectedCategories: string[] | undefined;
  selectedJobFamilies: string[] | undefined;
  selectedDataClassification: string[] | undefined;
  sortBy: SortOption | undefined;
  showBuilderHubBanner: boolean;
  showRecommended: boolean;
  recommendedTools: Map<string, AIForMeTool[]> | undefined;
  isInitialized: boolean;
  isUseCaseSearch: boolean | undefined;
}

export const useAllAiTools = (
  userInfo = UserInformation.current.getCachedAmazonianInformation() as AmazonianInformation
) => {
  const [inputs, setInputs] = useState<AllAiToolsState>({
    error: undefined,
    searchText: undefined,
    searchInputValue: "",
    selectedCategories: undefined,
    selectedJobFamilies: undefined,
    selectedDataClassification: undefined,
    sortBy: sortingOptions[0],
    showBuilderHubBanner: userInfo?.jobInfo.isTechnicalRole,
    showRecommended: false,
    recommendedTools: undefined,
    isInitialized: false,
    userFeedbacks: {},
    isUseCaseSearch: undefined,
  });

  type StateKey = keyof AllAiToolsState;

  const updateInputs = <K extends StateKey>(field: K, value: AllAiToolsState[K]) => {
    setInputs((prev) => {
      if (prev[field] !== value) {
        return {
          ...prev,
          [field]: value,
        };
      }
      return prev;
    });
  };

  return { inputs, updateInputs };
};
